import React from 'react';

import * as S from './styles';

const Label: React.FC = ({children}) => {
    return <S.TextLabel>{children}</S.TextLabel>
};

export default Label;